import { axiosInstance } from './config/instance'
import { SERVER } from './config/url'

const BANNERS_SERVICE_URL = `${SERVER}/banners-service-console/api/v1`
const ENTITY = 'banner'

export const banner = Object.freeze({
  async fetchList(data) {
    const response = await axiosInstance.post(`${BANNERS_SERVICE_URL}/${ENTITY}/search`, data)
    return response.data
  },
  async fetchItem(id) {
    const response = await axiosInstance.get(`${BANNERS_SERVICE_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async deleteItem(id) {
    const response = await axiosInstance.delete(`${BANNERS_SERVICE_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async createItem(data) {
    const response = await axiosInstance.post(`${BANNERS_SERVICE_URL}/${ENTITY}/add`, data)
    return response.data
  },
  async updateItem({ id, data }) {
    const response = await axiosInstance.put(`${BANNERS_SERVICE_URL}/${ENTITY}/${id}`, data)
    return response.data
  },
})
